import { Entity, Field } from 'typegraph';
import Entry from './Entry';
import { ID } from 'common/entities/IEntity';

@Entity({many: "userBundleEntries"})
export default class BundleEntry {

	@Field({entity: Entry})
	public entryDetails: Entry;

	@Field()
	public bundleIds:ID[];
}



// WEBPACK FOOTER //
// ./src/panels/bundleEntries/entities/BundleEntry.ts